/**
 * Created by liux on 2017/12/27.
 * @param {"jumpUrl":"http://www.baidu.com"，pageTitle"：''，callback：'window.callback',data[String]打开webview的时候传给下一个页面的数据，如果有的话注入到window.xyInitData = params.data}
 * @return Boolean
 *
 *statusBarStyle  字符串类型，值："light", "dark"  状态栏字体颜色
 * hideNavBar  布尔类型，值：true, false,   是否隐藏导航栏
 */
import xyJsBridge from './xyJsBridge'
import appInfo from '../helper/getAppInfo'
import replaceDomain from 'bjxy-common/xyHelper/replaceDomain'

function openH5Page(url, data) {
  var params={};
  if(url && typeof url === 'object'){
    params = url
  }else {
    params.jumpUrl = url;
    params.data = data
  }
  if(params.jumpUrl && /^http(s)?:\/\//.test(params.jumpUrl)) {
    params.jumpUrl = replaceDomain(params.jumpUrl)
  }
  if(params.data && typeof params.data === 'object'){
    params.data = encodeURIComponent(JSON.stringify(params.data))

    /*兼容钱包ios xyInitData*/
    if (appInfo().os === 'ios') {
      params.data = encodeURIComponent(params.data)
      params.xyInitData = params.data
      delete params.data
    }

  }
  return xyJsBridge('jsbridge://www.xiaoying.com/app/operation/openH5Page',params)
}

export default openH5Page
